import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ncgr-mar-b-16" }
const _hoisted_2 = { class: "ncgr-table -size-s -density-dense" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", null, " サイズ ", -1)
const _hoisted_4 = { class: "ncgr-typography-bold" }
const _hoisted_5 = { class: "ncgr-mar-b-16" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "ncgr-heading -size-s" }, " 型番 ", -1)
const _hoisted_7 = { class: "ncgr-ul -density-dense" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "ncgr-heading -size-s" }, " 素材・材質 ", -1)
const _hoisted_9 = { class: "ncgr-ul -density-dense" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_3,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
              return (_openBlock(), _createElementBlock("th", {
                key: index,
                class: "ncgr-align-right"
              }, _toDisplayString(header), 1))
            }), 128))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizes, (cols, size) => {
            return (_openBlock(), _createElementBlock("tr", { key: size }, [
              _createElementVNode("td", _hoisted_4, _toDisplayString(size), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cols, (col, index) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: index,
                  class: "ncgr-align-right"
                }, _toDisplayString(col), 1))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("ul", _hoisted_7, [
        _createElementVNode("li", null, _toDisplayString(_ctx.$t(`item-name.${_ctx.itemName}.long`)), 1),
        _createElementVNode("li", null, " 在庫切れの際に使用: " + _toDisplayString(_ctx.t(`substitute.${_ctx.itemName}`)), 1)
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_8,
      _createElementVNode("ul", _hoisted_9, [
        _createElementVNode("li", null, _toDisplayString(_ctx.t(`fabric.${_ctx.itemName}`)), 1)
      ])
    ])
  ]))
}